module.exports = "<p>\n  pdf-forms works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pdf-forms/pdf-forms.component.html
// module id = ./src/app/pdf-forms/pdf-forms.component.html
// module chunks = main